// This file is auto-generated by scripts/generate-models.ts
// Do not edit manually - run 'npm run generate-models' to update

import type { Model } from "../types.ts";

export const XIAOMI_TOKEN_PLAN_AMS_MODELS = {
	"mimo-v2-pro": {
		id: "mimo-v2-pro",
		name: "MiMo-V2-Pro",
		api: "openai-completions",
		provider: "xiaomi-token-plan-ams",
		baseUrl: "https://token-plan-ams.xiaomimimo.com/v1",
		compat: {"requiresReasoningContentOnAssistantMessages":true,"thinkingFormat":"deepseek"},
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0,
			output: 0,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 1048576,
		maxTokens: 131072,
	} satisfies Model<"openai-completions">,
	"mimo-v2.5": {
		id: "mimo-v2.5",
		name: "MiMo-V2.5",
		api: "openai-completions",
		provider: "xiaomi-token-plan-ams",
		baseUrl: "https://token-plan-ams.xiaomimimo.com/v1",
		compat: {"requiresReasoningContentOnAssistantMessages":true,"thinkingFormat":"deepseek"},
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 0,
			output: 0,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 1048576,
		maxTokens: 131072,
	} satisfies Model<"openai-completions">,
	"mimo-v2.5-pro": {
		id: "mimo-v2.5-pro",
		name: "MiMo-V2.5-Pro",
		api: "openai-completions",
		provider: "xiaomi-token-plan-ams",
		baseUrl: "https://token-plan-ams.xiaomimimo.com/v1",
		compat: {"requiresReasoningContentOnAssistantMessages":true,"thinkingFormat":"deepseek"},
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0,
			output: 0,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 1048576,
		maxTokens: 131072,
	} satisfies Model<"openai-completions">,
} as const;
